var exports = {
  "$s": "CharacterCounter.module__counterButton___T3F4cX" + " " + "CharacterCounter.module__counter___T3F4cX",
  "N1": "CharacterCounter.module__counterSpan___T3F4cX" + " " + "CharacterCounter.module__counter___T3F4cX",
  "jL": "CharacterCounter.module__textDanger___T3F4cX",
  "gF": "CharacterCounter.module__textTertiary___T3F4cX",
};

module.exports = exports;
